import React from "react";

const ValidityComp = ({ form, handleChange }) => {
	return (
		<div className="card-box">
			<h6>Validity</h6>

			<div className="row g-2">
				<div className="col-6">
					<div className="d-flex justify-content-between">
						<label>Start date</label>
					</div>
					<input
						type="date"
						name="startDate"
						value={form.startDate}
						onChange={handleChange}
						className="form-control custom-input"
					/>
				</div>
				<div className="col-6">
					<div className="d-flex justify-content-between">
						<label>End date</label>
					</div>
					<input
						type="date"
						name="endDate"
						value={form.endDate}
						onChange={handleChange}
						className="form-control custom-input"
					/>
				</div>
			</div>
		</div>
	);
};

export default ValidityComp;
